import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';

import FormattedHTMLMessage from '../general/FormattedHTMLMessage';
import Icon from '../general/Icon';

export default function AddStationButton ({ type, onSelect, activeAddButton, disabled }) {
    const addButtonClassNames = classnames('btn-box btn-add', {
        selected: (activeAddButton === type),
    });

    return (
        <div className="stationFinder__modal-button">
            <button onClick={ () => onSelect(type) } className={ addButtonClassNames } disabled={ disabled }>
                <Icon className="box-icon" icon="add" />
                <FormattedHTMLMessage message={ `stationFinder.modal.${type}` } />
                { (activeAddButton === type) && <Icon icon="selected" className="selected-icon" /> }
            </button>
        </div>
    );
}

AddStationButton.propTypes = {
    type: PropTypes.string.isRequired,
    onSelect: PropTypes.func.isRequired,
    activeAddButton: PropTypes.string,
    disabled: PropTypes.bool
};

AddStationButton.defaultProps = {
    activeAddButton: null,
    disabled: false
};



// WEBPACK FOOTER //
// ./src/components/stationFinder/AddStationButton.js